import { render, staticRenderFns } from "./ed-invite-substitute-teacher.component.vue?vue&type=template&id=5a452c61&scoped=true&"
import script from "./ed-invite-substitute-teacher.component.ts?vue&type=script&lang=ts&"
export * from "./ed-invite-substitute-teacher.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-invite-substitute-teacher.component.scss?vue&type=style&index=0&id=5a452c61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a452c61",
  null
  
)

export default component.exports